<template>
  <div>
    <div class="form-section">
      <form-field icon="name" title="Action Config Name">
        <input v-model="internalAction.name"
          class="input"
          type="text"
          placeholder="Name">
      </form-field>

      <form-field icon="description" title="Action Config Description">
        <textarea
            v-model="internalAction.description"
            class="textarea"
            type="text"
            placeholder="Description"></textarea>
      </form-field>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Cloud Collection Options</legend>
        <div class="field">
          <b-checkbox v-model="internalAction.alertConfig.gameplan">
            Send Alert Data to GamePlan
          </b-checkbox>
        </div>
        <div class="field">
          <b-checkbox v-model="internalAction.logConfig.gameplan">
            Send Log Data to GamePlan
          </b-checkbox>
        </div>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Alert Collection Endpoints</legend>
        <endpoints-form
          :endpoints.sync="internalAction.alertConfig.endpoints"
          title="Remote Alert Collection Endpoints">
        </endpoints-form>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Log Collection Endpoints</legend>
        <endpoints-form
          :endpoints.sync="internalAction.logConfig.endpoints"
          title="Remote Log Collection Endpoints">
        </endpoints-form>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Local Console Logging</legend>
        <div class="field">
          <b-checkbox v-model="internalAction.alertConfig.consoleEnabled">
            Log Alert Data to the Console
          </b-checkbox>
        </div>
        <div class="field">
          <b-checkbox v-model="internalAction.logConfig.consoleEnabled">
            Log Log Data to the Console
          </b-checkbox>
        </div>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Cache Options</legend>
        <form-field icon="cal" title="Local Cache Days to Keep">
          <input v-model.number="internalAction.cacheConfig.days"
            class="input"
            type="number"
            placeholder="7">
        </form-field>
      </fieldset>
    </div>

    <div class="form-section">
      <fieldset class="fieldset">
        <legend>Data Collection Options</legend>
        <data-configs-form
          :data.sync="internalAction.alertConfig.data"
          title="Remote Alert"
          :showAutoSelect="!existing">
        </data-configs-form>
        <data-configs-form
          :data.sync="internalAction.logConfig.data"
          title="Remote Log"
          :showAutoSelect="!existing">
        </data-configs-form>
      </fieldset>
    </div>
  </div>
</template>

<script>
import DataConfigsForm from '@/components/actions/forms/DataConfigsForm.vue';
import EndpointsForm from '@/components/actions/forms/EndpointsForm.vue';
import FormField from '@/components/forms/FormField.vue';

export default {
  name: 'ActionsConfigForm',
  components: {
    DataConfigsForm,
    EndpointsForm,
    FormField,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
    validMessage: {
      type: String,
      default: null,
    },
  },
  beforeMount() {
    this.$emit('update:validMessage', this.validate());
  },
  watch: {
    internalAction: {
      deep: true,
      handler() {
        this.$emit('update:action', this.internalAction);
        this.$emit('update:validMessage', this.validate());
      },
    },
  },
  data() {
    return {
      internalAction: this.action,
      showLoader: false,
    };
  },
  computed: {
    // If it is an existing config, it will have an id
    existing() {
      return Object.prototype.hasOwnProperty.call(this.action, 'id');
    },
  },
  methods: {
    validate() {
      if (this.internalAction.name === '') {
        return 'Configuration must set a name';
      }
      if (this.internalAction.description === '') {
        return 'Configuration must set a description';
      }
      if (this.internalAction.cacheConfig.days === '') {
        return 'Configuration must set the Local Cache Days to Keep';
      }

      let message = null;
      this.internalAction.alertConfig.endpoints.forEach((e) => {
        if (e.url === '') {
          message = 'Configuration must set a URL for each endpoint';
        }
      });

      this.internalAction.logConfig.endpoints.forEach((e) => {
        if (e.url === '') {
          message = 'Configuration must set a URL for each endpoint';
        }
      });

      return message;
    },
  },
};
</script>
